<template>
  <b-modal
        :id="id"
        ref="modal"
        :title="modalTitle"
        no-close-on-backdrop
        centered
        title-class="font-18"
        v-bind="$attrs"
        @ok="handleOk"
        @hidden="handleHidden"
    >
      <validation-observer v-if="!loading" ref="form_observer">
        <component
            :is="form"
            ref="form"
            v-model="model"
            :errors="errors"
            :is-valid.sync="isValid"
            is-modal="true"
            v-bind="formProps"
            v-on="formListeners"
        >
        </component>
      </validation-observer>
      <div v-if="loading" class="d-flex">
        <i class="bx bx-loader bx-spin font-size-16 align-middle mx-auto"></i>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button
            :disabled="updating || loading"
            size="md"
            variant="primary"
            @click="ok()"
        >
          <i
              v-if="updating"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Simpan
        </b-button>
      </template>
    </b-modal>
</template>

<script>
import FormsModel from "@/components/forms/user";
import ModelCreateModal from "@/components/modals/modal-create.vue";

export default {
  extends: ModelCreateModal,
  props: {
    id: { type: String, required: true },
    modalTitle: {
      default() {
        return this.lodash.startCase(this.$t('create {something} new', {something: this.$t('users.singular')}));
      },
    },
    resourceRoute: { default: "jala_investor_users" },
    modelVariable: { default: "jala_investor_user" },
    form: {
      type: Object,
      default: function () {
        return FormsModel;
      },
    },
    formProps: {
      type: Object,
      default: function () {
        return {};
      },
    },
    formListeners: {
      type: Object,
      default: function () {
        return {};
      },
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      isValid: true,
      updating: false,
      model: {
        ...this.initialValue,
        user: {
          ...(this.initialValue.user || {}),
        },
      },
      errors: {},
    };
  },
  methods: {
    resetModel() {
      this.$set(this, "model", {
        ...this.initialValue,
        user: {
          ...(this.initialValue.user || {}),
        },
      });
      this.errors = {};
      this.isValid = true;
    },
    handleHidden() {
      this.resetModel();
    },
    handleOk(event) {
      event.preventDefault();
      if (!("validateAll" in this.$refs.form)) return;
      this.$refs.form.validateAll().then((isValid) => {
        this.isValid = isValid;
        if (this.isValid) {
          this.$nextTick(() => {
            this.handleStore(this.model);
          });
        }
      });
    },
    handleStore(value) {
      this.updating = true;
      return this.store(value)
        .then((res) => {
          const { data: { data } } = res;
          const name = (data || {}).name || 'User';
          this.$toast(this.$t("Success! You have successfully added {name}", { name }), {
            type: 'success'
          });
          this.$emit("created", data);
          this.$refs.modal.hide();
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => {
          this.updating = false;
        });
    },
    store(value) {
      return this.$axios.post('users', {
        name: value.name,
        email: value.email,
        phone: value.phone,
        position: value.position,
        roles: value.roles,
      }).then((response) => {
        return response;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #1664D8;
  }

  .modal-dialog {
    max-width: 720px !important;
  }

}
</style>
